import { useTranslation } from 'react-i18next'

import Button from 'components/tailwind/Button'
import Modal from 'components/tailwind/Modal'
import { Heading } from 'components/ui/Heading'
import { useDiscover } from 'features/discover/hooks/useDiscover'
import { MESSAGE_ROLES, MESSAGE_TYPES } from 'features/discover/utils'
import { delayedAction } from 'helpers'

export default function CompletionSummaryModal({ onCompletionClose }) {
  const { t } = useTranslation()

  const {
    completionSummaryModalOpen,
    setCompletionSummaryModalOpen,
    enableAssistant,
    sendMessageToAssistant,
    hideAssistant,
    setAssistantIsTyping
  } = useDiscover()

  const handleErfahreMehr = () => {
    setCompletionSummaryModalOpen(false)
    enableAssistant()

    delayedAction(() => {
      sendMessageToAssistant({
        id: 'features',
        role: MESSAGE_ROLES.ASSISTANT,
        type: MESSAGE_TYPES.VIDEO,
        videoMessageProps: {
          isPulsing: true,
          title: 'Features entdecken',
          description: `Schon begeistert? Dann wirst du lieben, was Aivy noch alles draufhat!
                                
Von **Fragen für das Interview** bis hin zu **Team-Insights** und **Integration in eure HR-Systeme** – unsere Lösung wächst flexibel mit deinen Anforderungen.
                                
Gibt es ein Feature, über das du **mehr erfahren möchtest**?`,
          videoSrc:
            'https://aivy-assets.s3.eu-central-1.amazonaws.com/videos/Onboarding_2.mp4',
          ctaPrimary: {
            title: 'Mehr Features entdecken',
            onClick: () => {
              delayedAction(() => {
                sendMessageToAssistant({
                  id: 'feature-explore',
                  role: MESSAGE_ROLES.ASSISTANT,
                  type: MESSAGE_TYPES.FEATURE,
                  featureProps: {
                    isPulsing: true,
                    ctaPrimary: {
                      title: 'Onboarding abschließen',
                      onClick: () => {
                        hideAssistant()
                        if (onCompletionClose) {
                          onCompletionClose()
                        }
                      }
                    }
                  }
                })
              })
            }
          }
        }
      })
    }, 500)
  }

  return (
    <Modal
      open={completionSummaryModalOpen}
      setOpen={setCompletionSummaryModalOpen}
      size='3xl'
      borderRadius='rounded-3xl'
      disableOverlayClose
    >
      <div className='mx-auto flex max-w-3xl flex-col items-center gap-8'>
        <div className='flex w-full flex-col items-center justify-center'>
          <Heading level={1} className='text-pretty text-center'>
            <b>Super, du hast alle 3 Schritte abgeschlossen!</b>
          </Heading>
        </div>

        <div className='flex w-full flex-col items-center justify-center text-center'>
          <p className='text-lg text-gray-700'>
            <b>Anforderungsanalyse, Stärkentest und Matching.</b>
          </p>
          <p className='mt-4 text-lg text-gray-700'>
            So schnell hast du einen{' '}
            <b>kompletten Überblick über deine Talente-Stellen-Passung!</b>
          </p>
        </div>

        <div className='flex w-full flex-col gap-3'>
          <Button.PrimaryXL
            text='Erfahre was Aivy noch kann'
            onClick={handleErfahreMehr}
          />
        </div>
      </div>
    </Modal>
  )
}
